import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { ArrowRight, Clock3, KeyRound, ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';

const DefaultPasswordWarning = () => {
  const navigate = useNavigate();
  const { showDefaultPasswordWarning, dismissDefaultPasswordWarning } = useAuth();

  const handleChangeNow = () => {
    dismissDefaultPasswordWarning();
    navigate('/change-password');
  };

  return (
    <AlertDialog.Root
      open={showDefaultPasswordWarning}
      onOpenChange={(open) => {
        if (!open) dismissDefaultPasswordWarning();
      }}
    >
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="default-password-dialog__overlay" />
        <AlertDialog.Content className="default-password-dialog">
          <div className="default-password-dialog__icon" aria-hidden="true">
            <ShieldAlert />
          </div>

          <div className="default-password-dialog__heading">
            <span>账户安全提醒</span>
            <AlertDialog.Title>当前账户仍在使用默认密码</AlertDialog.Title>
          </div>

          <AlertDialog.Description className="default-password-dialog__description">
            默认密码容易被猜测。建议立即进入用户中心修改密码，避免账户和许可证数据被未授权访问。
          </AlertDialog.Description>

          <div className="default-password-dialog__tip">
            <KeyRound aria-hidden="true" />
            <div>
              <strong>建议设置独立密码</strong>
              <span>至少包含字母和数字，并避免与其他系统共用。</span>
            </div>
          </div>

          <div className="default-password-dialog__actions">
            <AlertDialog.Cancel asChild>
              <Button type="button" variant="outline" onClick={dismissDefaultPasswordWarning}>
                <Clock3 data-icon="inline-start" />
                稍后
              </Button>
            </AlertDialog.Cancel>
            <AlertDialog.Action asChild>
              <Button type="button" onClick={handleChangeNow}>
                现在修改
                <ArrowRight data-icon="inline-end" />
              </Button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};

export default DefaultPasswordWarning;
